import { IGetEventsDetailsResponse, sortEvents } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortEvents',
  standalone: true,
})
export class SortEventsPipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(
    allEvents: IGetEventsDetailsResponse[],
    sortBy: string,
    trackType: string[],
    listFavorites?: Set<string>
  ): any {
    return sortEvents(allEvents, sortBy, trackType, listFavorites);
  }

}
